import React from 'react';
import { FaSort, FaSortDown, FaSortUp } from 'react-icons/fa';

export const alternarOrdenacao = (ordenacaoAtual, key) => ({
  key,
  direction:
    ordenacaoAtual && ordenacaoAtual.key === key && ordenacaoAtual.direction === 'asc'
      ? 'desc'
      : 'asc',
});

const compararValores = (valorA, valorB) => {
  const vazioA = valorA === null || valorA === undefined || valorA === '';
  const vazioB = valorB === null || valorB === undefined || valorB === '';
  if (vazioA && vazioB) return 0;
  if (vazioA) return 1;
  if (vazioB) return -1;

  if (typeof valorA === 'number' && typeof valorB === 'number') {
    return valorA - valorB;
  }

  return String(valorA).localeCompare(String(valorB), 'pt-BR', {
    numeric: true,
    sensitivity: 'base',
  });
};

export const ordenarRegistros = (registros, ordenacao, colunas) => {
  if (!ordenacao || !ordenacao.key || !colunas || !colunas[ordenacao.key]) {
    return registros;
  }

  const obterValor = colunas[ordenacao.key];
  const direcao = ordenacao.direction === 'desc' ? -1 : 1;

  return [...registros]
    .map((item, index) => ({ item, index }))
    .sort((a, b) => {
      const comparacao = compararValores(obterValor(a.item), obterValor(b.item));
      if (comparacao === 0) return a.index - b.index;
      return comparacao * direcao;
    })
    .map(({ item }) => item);
};

const SortableHeader = ({ children, sortKey, ordenacao, onSort, className = '' }) => {
  const ativo = ordenacao && ordenacao.key === sortKey;
  const direcao = ativo ? ordenacao.direction : null;
  const Icon = !ativo ? FaSort : direcao === 'asc' ? FaSortUp : FaSortDown;

  return (
    <th
      className={`hpj-sortable-th ${ativo ? 'hpj-sortable-th--active' : ''} ${className}`.trim()}
      aria-sort={ativo ? (direcao === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <button
        type="button"
        className="hpj-sort-button"
        onClick={() => onSort(sortKey)}
      >
        <span>{children}</span>
        <Icon aria-hidden="true" />
      </button>
    </th>
  );
};

export default SortableHeader;
